<section class="camera-monitor" *ngIf="location">
  <div class="camera-state loading" *ngIf="loading">
    <span class="camera-loader" aria-hidden="true"></span>
    <div><strong>Cargando datos de la cámara</strong><small>Consultando alarmas y último dato disponible...</small></div>
  </div>

  <div class="camera-state error" *ngIf="!loading && loadError">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <div><strong>No fue posible cargar la cámara</strong><small>Intenta nuevamente en unos momentos.</small></div>
    <button type="button" (click)="fetchData()">Reintentar</button>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <header class="camera-summary">
      <span class="camera-avatar"><i class="fa fa-video-camera" aria-hidden="true"></i></span>
      <div class="camera-identity">
        <small>Dispositivo monitoreado</small>
        <h2>{{ deviceDescription }}</h2>
        <p><i class="fa fa-map-marker" aria-hidden="true"></i>{{ location.name || 'Ubicación sin nombre' }}</p>
      </div>
      <span class="alarm-status" [class.has-alarms]="alarmList.length">
        <i class="fa" [ngClass]="alarmList.length ? 'fa-exclamation-circle' : 'fa-check-circle'"></i>
        {{ alarmList.length ? (alarmList.length + ' alarmas hoy') : 'Sin alarmas hoy' }}
      </span>
    </header>

    <div class="camera-metrics">
      <article><span>Tipo</span><strong>{{ deviceTypeName }}</strong><small>Clasificación del activo</small></article>
      <article><span>Altitud</span><strong>{{ altitudeLabel }}</strong><small>Altura configurada</small></article>
      <article><span>Último dato</span><strong>{{ lastSensorData?.create_date ? (lastSensorData.create_date | date:'dd/MM/yyyy HH:mm') : 'Sin datos' }}</strong><small>Última comunicación</small></article>
      <article><span>Capturas</span><strong>{{ slides.length }}</strong><small>Imágenes asociadas hoy</small></article>
    </div>

    <section class="camera-panel alarm-history">
      <div class="camera-panel-heading">
        <div><h3>Alarmas últimas 24 horas</h3><p>Distribución de eventos registrados durante el día.</p></div>
        <span>{{ alarmList.length }} evento{{ alarmList.length === 1 ? '' : 's' }}</span>
      </div>

      <div class="camera-chart">
        <app-custom-stepline
          [data]="chart.data"
          [title]="chart.title"
          [label]="chart.label"
          [compact]="true"
          [compactHeight]="230"
          [reduceGrid]="true">
        </app-custom-stepline>
      </div>
      <div class="camera-empty-note" *ngIf="!alarmList.length">
        <i class="fa fa-check-circle"></i>
        Sin alarmas activas: el gráfico representa el período sin eventos registrados.
      </div>
    </section>

    <section class="camera-panel captures-panel">
      <div class="camera-panel-heading">
        <div><h3>Capturas asociadas</h3><p>Evidencia visual recibida junto con las alarmas.</p></div>
        <span>{{ slides.length }} imagen{{ slides.length === 1 ? '' : 'es' }}</span>
      </div>

      <swiper-container *ngIf="slides.length; else noCaptures" [pagination]="true" [options]="slideOpts">
        <swiper-slide *ngFor="let slide of slides; let index = index">
          <img [src]="slide.img" [alt]="'Captura ' + (index + 1) + ' de ' + deviceDescription" loading="lazy">
        </swiper-slide>
      </swiper-container>
      <ng-template #noCaptures>
        <div class="camera-empty compact"><i class="fa fa-picture-o"></i><strong>Sin capturas disponibles</strong><small>Las alarmas actuales no tienen imágenes asociadas.</small></div>
      </ng-template>
    </section>
  </ng-container>
</section>
